module.exports = __webpack_public_path__ + "assets/img/2021-11-active.9181915d.png";